import {
  genericCreate,
  genericFind,
  genericGet,
  genericRemove,
} from '@/services/common';

import update from './update';

export const create = genericCreate('vendor');

export const find = genericFind('vendor');

export const get = genericGet('vendor');

export const remove = genericRemove('vendor');

export * from './types';

export default {
  create,
  find,
  get,
  remove,
  update,
};
